import type { RuleSet } from '../rules/schema';
import { matchDuration, type SimState } from '../sim';

/**
 * Whole seconds the match clock reads at sim time `at` (`state.elapsed` is
 * now). Timed: the time left, rounded up, so it reads 0:00 only once the
 * match has ended rather than for the whole last second. No limit: the time
 * played, counting up.
 */
export function clockSeconds(state: SimState, rules: RuleSet, at: number): number {
  const duration = matchDuration(state, rules);
  return duration === null ? Math.floor(at + 1e-6) : Math.max(0, Math.ceil(duration - at - 1e-6));
}

/** 75 → "1:15" (whole seconds, as given). */
export function clockLabel(seconds: number): string {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
